export const APPEARANCES = {
  default: 'default',
  accent: 'accent',
  cta: 'cta',
  danger: 'danger',
  gradient: 'gradient',
};

export const FONT_WEIGHTS = {
  medium: 'medium',
  regular: 'regular',
};

export const FORMATS = {
  solid: 'solid',
  outline: 'outline',
  solidWhite: 'solid-white',
  text: 'text',
};

export const ICON_PLACEMENTS = {
  after: 'after',
  before: 'before',
};

export const SIZES = {
  large: 'large',
  medium: 'medium',
  small: 'small',
  extraLarge: 'extra-large',
};

export const FONT_SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  inherit: 'inherit',
};
